import Vue from 'vue';
import * as R from 'ramda';
Vue.prototype.$R = R;
